import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center font-mono text-sm text-slate-500">Memuat sesi...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
